import React from 'react'
import classNames from 'classnames'
import { ClassValue } from 'classnames/types'

interface AmazonLinkProps {
    asin: string
    text?: string
    className?: ClassValue
    screenshotMode?: boolean
}

export const AmazonLink = ({
    asin,
    text,
    className,
    screenshotMode = false,
}: AmazonLinkProps): JSX.Element => {
    return (
        <a
            className={classNames(className, { blur: screenshotMode })}
            href={`https://${window.marketplace.domain}/dp/${asin?.toUpperCase()}`}
            target="_blank"
            rel="noreferrer"
        >
            {text || asin?.toUpperCase()}
        </a>
    )
}

interface AmazonSearchLinkProps {
    query: string
    text?: string
    className?: ClassValue
    screenshotMode?: boolean
}

export const AmazonSearchLink = ({
    query,
    text,
    className,
    screenshotMode = false,
}: AmazonSearchLinkProps): JSX.Element => {
    return (
        <a
            className={classNames(className, { blur: screenshotMode })}
            href={`https://${window.marketplace.domain}/s?k=${query}`}
            target="_blank"
            rel="noreferrer"
        >
            {text || query}
        </a>
    )
}

export const isAsin = (asin: string): boolean => {
    // Look for a string 10 chars long starting with "B"
    const preliminaryChecks = asin.length === 10 && asin.substr(0, 1).toLowerCase() === 'b'
    if (!preliminaryChecks) {
        return false
    }

    // Ensure all character are alpha numeric
    for (let i = 0; i < asin.length; i++) {
        if (!isAlphaNumeric(asin.charCodeAt(i))) {
            return false
        }
    }

    return true
}

const isAlphaNumeric = (character: number): boolean => {
    return (
        (character >= 97 && character <= 122) /* a-z */ ||
        (character >= 65 && character <= 90) /* A-Z */ ||
        (character >= 48 && character <= 57) /* 0-9 */
    )
}
